import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV, SITE } from "../../content/site";

export const Nav = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-300 ${
        isScrolled ? "bg-cream/95 backdrop-blur border-b border-light-grey" : "bg-cream"
      }`}
      data-testid="site-nav"
    >
      <div className="container-site flex items-center justify-between h-20 md:h-24">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo-link">
          <img
            src={SITE.logoUrl}
            alt="Fourbees Consultancy"
            className="h-14 md:h-16 w-auto mix-blend-multiply"
          />
          <span className="sr-only">{SITE.name}</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((item) => (
            <NavLink
              key={item.href}
              to={item.href}
              end={item.href === "/"}
              className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
              data-testid={`nav-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {item.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            className="btn-primary ml-2"
            data-testid="nav-cta"
          >
            Let's Talk
          </Link>
        </nav>

        <button
          onClick={() => setIsOpen(true)}
          className="lg:hidden p-2 text-navy"
          aria-label="Open menu"
          data-testid="nav-mobile-open"
        >
          <Menu size={22} />
        </button>
      </div>

      <div
        className={`fixed inset-0 bg-cream z-[60] transition-transform duration-300 ease-out lg:hidden ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
        style={{ backgroundColor: "#F8F7F3" }}
        data-testid="nav-mobile-sheet"
      >
        <div className="container-site py-6 h-full flex flex-col">
          <div className="flex items-center justify-between">
            <img
              src={SITE.logoUrl}
              alt="Fourbees Consultancy"
              className="h-12 w-auto mix-blend-multiply"
            />
            <button
              onClick={() => setIsOpen(false)}
              aria-label="Close menu"
              className="p-2 text-navy"
              data-testid="nav-mobile-close"
            >
              <X size={22} />
            </button>
          </div>
          <nav className="flex flex-col gap-1 mt-12">
            {NAV.map((item, i) => (
              <NavLink
                key={item.href}
                to={item.href}
                end={item.href === "/"}
                className={({ isActive }) =>
                  `font-heading text-3xl py-3 border-b border-light-grey ${
                    isActive ? "text-navy" : "text-navy/60"
                  }`
                }
                data-testid={`nav-mobile-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <span className="section-number mr-4">0{i + 1}</span>
                {item.label}
              </NavLink>
            ))}
          </nav>
          <Link
            to="/contact"
            onClick={() => setIsOpen(false)}
            className="btn-primary mt-10 w-full"
            data-testid="nav-mobile-cta"
          >
            Let's Talk About Your Business
          </Link>
        </div>
      </div>
    </header>
  );
};
